import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TimeService } from 'src/app/services/time-service/time.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent {
  
  @Input() startDate:Date = new Date();
  @Input() toDate: string;
  @Input() dateFormat:string;
  
  @Input() datePickerOptionsFromMin:string;
  @Input() datePickerOptionsFromMax: string;
  @Input() datePickerOptionsToMin: string;
  @Input() datePickerOptionsToMax: string;

  @Input() fromMaxBeforeCurrentDate:boolean = false;

  private _fromDate: string;
  @Input() set fromDate(value: string) {
    if( value !== this._fromDate) {
      this._fromDate = value;
      if(this.dateRange && value) {
        this.disableSinceFrom();
        this.onDateChangedFromValue(value);
      }
    }
    else {
      this._fromDate = value;
    }
  }
  get fromDate(): string {
    return this._fromDate;
  }

  private _dateRange: number;
  @Input() set dateRange(value: number) {
    if( value !== this._dateRange) {
      this._dateRange = value;
      if(this.fromDate && value) {
        this.onDateChangedFromValue(this.fromDate);
      }
    }
    else {
      this._dateRange = value;
    }
  }
  get dateRange(): number {
    return this._dateRange;
  }

  @Output() calendarUpdate: any;  

  public searchDisabled = true;
  public jsDateObject: any;
  public useDateToAsFromMax:boolean = false; // true: use DateTo As FromMax, otherwise , use today

  constructor(
    private timeService: TimeService
    ) {
      this.calendarUpdate = new EventEmitter<any>();
      this.dateRange = this.dateRange || 14;
      this.toDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(new Date()));
      this.fromDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(new Date(this.startDate.setDate(this.startDate.getDate() - this.dateRange))));
      this.dateFormat = 'MM-dd-yyyy';

      this.disableSinceFrom();
      this.disableSinceTo();
      this.disableUntilTo();
     }

  disableSinceFrom() {
    let todayDate: Date = new Date();
    if(this.fromMaxBeforeCurrentDate) {
      todayDate.setDate(todayDate.getDate() -1);
    }
    const todayISOStr = todayDate.toISOString();
    const todayDateOnlyISOStr = todayISOStr.split('T')[0];
    const fromMax = this.useDateToAsFromMax ? this.toDate : todayDateOnlyISOStr;
    this.datePickerOptionsFromMax = todayDateOnlyISOStr >= fromMax ? fromMax : todayISOStr;
  }
  
  disableSinceTo() {
    let d: Date = new Date(this.fromDate);
    this.datePickerOptionsToMin = d.toISOString() >= this.fromDate ? this.fromDate : d.toISOString();
  }

  disableUntilTo() {
    let d: Date = new Date(this.fromDate);
    d.setDate(new Date(this.fromDate).getDate() + this.dateRange);
    this.datePickerOptionsToMax = new Date() >= d ? d.toISOString() : new Date().toISOString();
  }

  onDateChangedFrom(event: any) {
    this.onDateChangedFromValue(event.target.value);
    this.onCalendarUpdate();
  }

  onDateChangedFromValue(value: string) {
    this.fromDate = value.split('T')[0];
    this.jsDateObject = this.fromDate + 'T00:00:00';
    let toDateForward = new Date(this.jsDateObject);
    toDateForward.setDate(toDateForward.getDate() + this.dateRange); //add 2 weeks to 'toDate' automatically when user picks a date
    this.toDate = toDateForward <= new Date() ? toDateForward.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
    this.disableSinceTo();
    this.disableUntilTo();
  }

  onDateChangedTo(event: any) {
    this.onDateChangedToValue(event.target.value);
    this.onCalendarUpdate();
  }

  onDateChangedToValue(value: string) {
    this.toDate = value.split('T')[0];
    if(this.useDateToAsFromMax) {
      this.disableSinceFrom();
    }
  }

  onCalendarUpdate() {
    this.calendarUpdate.emit({
      fromDate: this.fromDate,
      toDate: this.toDate,
      search: !this.searchDisabled
    });
  }
}
